import { v4 as uuid4 } from 'uuid';
import { Editor, Path, Transforms } from 'slate';
import { insertVoidElement } from '../../lib/commands';
import { PlanetEStreamEntity, planetEStreamType } from './planetEStreamType';
import { AulaEditorInstance } from '../../types';

export const insertPlanetEStream = (
  editor: AulaEditorInstance,
  path: Path,
  createEntity: (ent: PlanetEStreamEntity) => string,
) => {
  const linkId = uuid4();
  const entity = createEntity({
    type: 'lti',
    /** An LTI block is accepted to be in the progress of loading data,
     * if its data field is empty. Currently planet eStream LTI blocks
     *  don't receive message after content selection so a random link
     *  id is explicitly set immediately after adding the block to the
     *  document.
     */
    data: { linkId },
    linkId,
  });

  setTimeout(() => {
    // insert at the end of current block
    const end = Editor.end(editor, path);
    Transforms.select(editor, end);
    insertVoidElement(editor, {
      type: planetEStreamType,
      linkId,
      entity,
    });
  }, 50);
};
